import ComplimentaryAccessSettings from '../components/ComplimentaryAccessSettings';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API } from '../App';
import { ManageFreeAccess, PlanAccessSummary } from '../components/PsychologistAccess';

export default function AdminPsychologistPlans() {
  const [people, setPeople] = useState(null);
  const [search, setSearch] = useState('');
  const [approval, setApproval] = useState('all');
  const [period, setPeriod] = useState('all');
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    axios.get(`${API}/admin/psychologists`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` } })
      .then(r => { if (active) setPeople(r.data); })
      .catch(() => { if (active) setError('Unable to load psychologist plans. Reload to try again.'); });
    return () => { active = false; };
  }, []);
  const filtered = (people || []).filter(p => {
    const end = p.platform_access?.effective_expires_at || p.platform_access?.expires_at;
    const state = end ? (new Date(end) <= new Date() ? 'expired' : 'active') : 'undated';
    return `${p.name} ${p.id} ${p.email || ''}`.toLowerCase().includes(search.toLowerCase()) &&
      (approval === 'all' || p.approval_status === approval) && (period === 'all' || period === state);
  });
  return <main className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 p-4 md:p-8">
    <div className="max-w-6xl mx-auto">
      <Link to="/admin-dashboard" className="text-purple-700 underline">← Back to Administration</Link>
      <h1 className="text-3xl font-bold mt-4">Psychologist Plans</h1>
      <p className="mt-2">Manage individual complimentary extensions. Account approval and existing entitlements remain separate.</p>
      <ComplimentaryAccessSettings nativeDialog />
      <section aria-label="Plan filters" className="my-5 flex flex-wrap gap-4">
        <label>Search name, identifier or email<input className="block border rounded p-2 w-full" value={search} onChange={e => setSearch(e.target.value)} /></label>
        <label>Approval status<select className="block border rounded p-2" value={approval} onChange={e => setApproval(e.target.value)}>{['all','approved','pending','rejected'].map(v => <option key={v} value={v}>{v}</option>)}</select></label>
        <label>Complimentary period<select className="block border rounded p-2" value={period} onChange={e => setPeriod(e.target.value)}>{['all','active','expired','undated'].map(v => <option key={v} value={v}>{v}</option>)}</select></label>
      </section>
      {error && <p role="alert">{error}</p>}
      {!people && !error && <p role="status">Loading psychologist plans…</p>}
      {people && <p role="status">{filtered.length} psychologist(s)</p>}
      <div className="grid md:grid-cols-2 gap-4 mt-4">{filtered.map(p => <article key={p.id} className="bg-white border rounded-lg p-5 min-w-0 break-words">
        <h2 className="text-xl font-semibold">{p.name}</h2><p className="text-sm">Identifier: {p.id}</p>
        <p>Approval: {p.approval_status || 'Not recorded'}{p.is_active === false ? ' · Account deactivated' : ''}</p>
        <PlanAccessSummary access={p.platform_access} history={p.platform_access_history} />
        {!p.platform_access?.expires_at && <p className="text-sm mb-3">No dated entitlement to extend. Existing access is preserved.</p>}
        <ManageFreeAccess psychologist={p} extensionsOnly onSaved={access => setPeople(current => current.map(row => row.id === p.id ? {...row, platform_access: access} : row))} />
      </article>)}</div>
    </div>
  </main>;
}
